export const bodyMap = new Map([
  [
    "NeckMaterial",
    {
      bodyPart: "Neck",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary Movement",
      ],
      withoutAttorney: 4.3,
      withAttorney: 343,
    },
  ],
  [
    "HeadMaterial",
    {
      bodyPart: "Head",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Seizure",
        "Coma",
        "Hallucination",
        "Headache",
        "Dizziness",
      ],
      withoutAttorney: 4.7,
      withAttorney: 2047,
    },
  ],
  [
    "RightShoulderMaterial",
    {
      bodyPart: "Right Shoulder",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Unable to stand or walk",
        "Nerve, muscle or tendon damage",
        "Bone removal",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftShoulderMaterial",
    {
      bodyPart: "Left Shoulder",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Unable to stand or walk",
        "Nerve, muscle or tendon damage",
        "Bone removal",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "ChestMaterial",
    {
      bodyPart: "Chest",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Tightness",
        "Irregular bowel movements",
        "Vomiting",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "CoreMaterial",
    {
      bodyPart: "Stomach",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Tightness",
        "Irregular bowel movements",
        "Vomiting",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightRibsMaterial",
    {
      bodyPart: "Right Ribs",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Tightness",
        "Irregular bowel movements",
        "Vomiting",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftRibsMaterial",
    {
      bodyPart: "Left Ribs",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Tightness",
        "Irregular bowel movements",
        "Vomiting",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "UpperBackMaterial",
    {
      bodyPart: "Upper Back",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Unable to stand or walk",
        "Nerve, muscle or tendon damage",
        "Bone removal",
      ],
      withoutAttorney: 4.5,
      withAttorney: 345,
    },
  ],
  [
    "RightMidBackMaterial",
    {
      bodyPart: "Right Mid Back",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Unable to stand or walk",
        "Nerve, muscle or tendon damage",
        "Bone removal",
      ],
      withoutAttorney: 4.5,
      withAttorney: 345,
    },
  ],
  [
    "LeftMidBackMaterial",
    {
      bodyPart: "Left Mid Back",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Unable to stand or walk",
        "Nerve, muscle or tendon damage",
        "Bone removal",
      ],
      withoutAttorney: 4.5,
      withAttorney: 345,
    },
  ],
  [
    "LowerBackMaterial",
    {
      bodyPart: "Lower Back",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Unable to stand or walk",
        "Nerve, muscle or tendon damage",
        "Bone removal",
      ],
      withoutAttorney: 4.5,
      withAttorney: 345,
    },
  ],
  [
    "RightBicepMaterial",
    {
      bodyPart: "Right Bicep",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightTricepMaterial",
    {
      bodyPart: "Right Tricep",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightElbowMaterial",
    {
      bodyPart: "Right Elbow",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightForearmMaterial",
    {
      bodyPart: "Right Forearm",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightHandMaterial",
    {
      bodyPart: "Right Hand",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftBicepMaterial",
    {
      bodyPart: "Left Bicep",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftTricepMaterial",
    {
      bodyPart: "Left Tricep",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftElbowMaterial",
    {
      bodyPart: "Left Elbow",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftForeArm",
    {
      bodyPart: "Left Forearm",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftHandMaterial",
    {
      bodyPart: "Left Hand",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightHipMaterial",
    {
      bodyPart: "Right Hip",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Hip replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftHipMaterial",
    {
      bodyPart: "Left Hip",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Hip replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "PelvisMaterial",
    {
      bodyPart: "Pelvis",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Pain during erection",
        "Pain during urination",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "ButtMaterial",
    {
      bodyPart: "Buttox",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Pain during erection",
        "Pain during urination",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightThighMaterial",
    {
      bodyPart: "Right Thigh",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightHamstringMaterial",
    {
      bodyPart: "Right Hamstring",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightKneeMaterial",
    {
      bodyPart: "Right Knee",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightCalfMaterial",
    {
      bodyPart: "Right Calf",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightLegMaterial",
    {
      bodyPart: "Right Leg",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightAnkleMaterial",
    {
      bodyPart: "Right Ankle",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "RightFootMaterial",
    {
      bodyPart: "Right Foot",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftThighMaterial",
    {
      bodyPart: "Left Thigh",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movement",
        "Impaired movement",
        "Knee replacement",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftHamstringMaterial",
    {
      bodyPart: "LeftHamstring",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftKneeMaterial",
    {
      bodyPart: "Left Knee",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftCalfMaterial",
    {
      bodyPart: "Left Calf",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftLegMaterial",
    {
      bodyPart: "Left Leg",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftAnkleMaterial",
    {
      bodyPart: "Left Ankle",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
  [
    "LeftFootMaterial",
    {
      bodyPart: "Left Foot",
      injuryList: [
        "Fracture or broken bone",
        "Bleeding or discharge",
        "Numb or tender",
        "Swelling",
        "Bruising or discoloration",
        "Involuntary movements",
        "Impaired movement",
        "Irregular armpit sweating",
        "Nerve, muscle or tendon damage",
        "Amputation or sever",
      ],
      withoutAttorney: 4.1,
      withAttorney: 254,
    },
  ],
]);

// Reverse lookup: bodyPart -> materialName
export const bodyPartToMaterial = new Map(
  Array.from(bodyMap.entries()).map(([material, data]) => [data.bodyPart, material])
);

// Get materialName from bodyPart
export function getMaterialName(bodyPart) {
  return bodyPartToMaterial.get(bodyPart) || `${bodyPart.replace(/\s+/g, '')}Material`;
}
